var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FileUpload, UploadStatus } from 'packages/core/files/FileUpload';
import { UploadTimeCalculator } from 'packages/core/files/UploadTimeCalculator';
import { UploadsRepository } from 'packages/files/UploadsRepository';
import { container } from 'tsyringe';
var TalentFileUpload = /** @class */ (function (_super) {
    __extends(TalentFileUpload, _super);
    function TalentFileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uploadRepo = container.resolve(UploadsRepository);
        return _this;
    }
    TalentFileUpload.prototype.upload = function (talentId, jobId) {
        var _this = this;
        this.timer = new UploadTimeCalculator();
        this.promise = this.uploadRepo.uploadFileForTalent(this.file, talentId, jobId, this.onUploadProgress.bind(this));
        this.promise.then(function (result) {
            _this.timer.stop();
            _this.status = UploadStatus.COMPLETE;
            return result;
        });
        this.timer.start();
        this.status = UploadStatus.UPLOADING;
        return this.promise;
    };
    return TalentFileUpload;
}(FileUpload));
export { TalentFileUpload };
